// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2Q1Nd","signatureButtonsRight":"ModalSign_signatureButtonsRight__1aNMc"};